import { TypedActionWithPayload } from '@/types/redux';

export const COMPLETE_COMPLETE_ACCOUNT_MODAL = 'COMPLETE_COMPLETE_ACCOUNT_MODAL';
export const COMPLETE_CONFIRM_PASSWORD_MODAL = 'COMPLETE_CONFIRM_PASSWORD_MODAL';
export const COMPLETE_FOLLOW_SEARCH_MODAL = 'COMPLETE_FOLLOW_SEARCH_MODAL';
export const COMPLETE_LOGIN_MODAL = 'COMPLETE_LOGIN_MODAL';
export const COMPLETE_SEND_SELLER_MESSAGE_MODAL = 'COMPLETE_SEND_SELLER_MESSAGE_MODAL';
export const COMPLETE_SIGN_UP_MODAL = 'COMPLETE_SIGN_UP_MODAL';

export const DISMISS_MODAL = 'DISMISS_MODAL';
export type DISMISS_MODAL_ACTION = TypedActionWithPayload<typeof DISMISS_MODAL>;

export const OPEN_ABSENTEE_BID_MODAL = 'OPEN_ABSENTEE_BID_MODAL';
export type OPEN_ABSENTEE_BID_MODAL_ACTION = TypedActionWithPayload<
    typeof OPEN_ABSENTEE_BID_MODAL,
    {
        bidAmount: number;
        itemId: number;
    }
>;

export const OPEN_ADD_BANK_ACCOUNT_MODAL = 'OPEN_ADD_BANK_ACCOUNT_MODAL';
export const OPEN_ADD_CREDIT_CARD_MODAL = 'OPEN_ADD_CREDIT_CARD_MODAL';
export const OPEN_ADD_SEARCH_ALERT_MODAL = 'OPEN_ADD_SEARCH_ALERT_MODAL';
export const OPEN_BID_LIMIT_EXCEEDED_MODAL = 'OPEN_BID_LIMIT_EXCEEDED_MODAL';
export const OPEN_BUY_NOW_MODAL = 'OPEN_BUY_NOW_MODAL';
export const OPEN_CATALOG_ANNOUNCEMENT_MODAL = 'OPEN_CATALOG_ANNOUNCEMENT_MODAL';
export const OPEN_CHANGE_PASSWORD_MODAL = 'OPEN_CHANGE_PASSWORD_MODAL';
export const OPEN_CLASSIC_BIDDING_CONSOLE_MODAL = 'OPEN_CLASSIC_BIDDING_CONSOLE_MODAL';
export const OPEN_COMPLETE_ACCOUNT_MODAL = 'OPEN_COMPLETE_ACCOUNT_MODAL';
export const OPEN_CONFIRM_PASSWORD_MODAL = 'OPEN_CONFIRM_PASSWORD_MODAL';
export const OPEN_CONSIGNMENT_CONFIRM_MODAL = 'OPEN_CONSIGNMENT_CONFIRM_MODAL';
export const OPEN_DELETE_ACCOUNT_CONFIRMATION_MODAL = 'OPEN_DELETE_ACCOUNT_CONFIRMATION_MODAL';
export const OPEN_DESCRIPTION_MODAL = 'OPEN_DESCRIPTION_MODAL';
export const OPEN_DOWNLOAD_MOBILE_MODAL = 'OPEN_DOWNLOAD_MOBILE_MODAL';
export const OPEN_FEEDBACK_MODAL = 'OPEN_FEEDBACK_MODAL';
export const OPEN_FORGOT_PASSWORD_MODAL = 'OPEN_FORGOT_PASSWORD_MODAL';
export const OPEN_HEALTHCHECK_MODAL = 'OPEN_HEALTHCHECK_MODAL';
export const OPEN_INSTALL_FLASH_MODAL = 'OPEN_INSTALL_FLASH_MODAL';
export const OPEN_ITEM_PAGE_FIRST_TIME_MODAL = 'OPEN_ITEM_PAGE_FIRST_TIME_MODAL';
export const OPEN_LIVE_BID_MODAL = 'OPEN_LIVE_BID_MODAL';
export const OPEN_LOGIN_MODAL = 'OPEN_LOGIN_MODAL';
export const OPEN_PREFERENCES_MODAL = 'OPEN_PREFERENCES_MODAL';
export const OPEN_REGISTER_FOR_CATALOG_MODAL = 'OPEN_REGISTER_FOR_CATALOG_MODAL';
export const OPEN_REPORT_REVIEW_MODAL = 'OPEN_REPORT_REVIEW_MODAL';
export const OPEN_RETRACT_BID_MODAL = 'OPEN_RETRACT_BID_MODAL';
export const OPEN_REVIEWS_MODAL = 'OPEN_REVIEWS_MODAL';
export const OPEN_SEND_SELLER_CONSIGNMENT_MESSAGE_MODAL = 'OPEN_SEND_SELLER_CONSIGNMENT_MESSAGE_MODAL';
export const OPEN_SEND_SELLER_MESSAGE_MODAL = 'OPEN_SEND_SELLER_MESSAGE_MODAL';
export const OPEN_SET_PASSWORD_MODAL = 'OPEN_SET_PASSWORD_MODAL';
export const OPEN_SHIPPING_AND_PAYMENT_MODAL = 'OPEN_SHIPPING_AND_PAYMENT_MODAL';
export const OPEN_SIGN_UP_MODAL = 'OPEN_SIGN_UP_MODAL';
export const OPEN_SMS_CONFIRMATION_MODAL = 'OPEN_SMS_CONFIRMATION_MODAL';
export const OPEN_TAX_EXEMPT_MODAL = 'OPEN_TAX_EXEMPT_MODAL';
export const OPEN_WAITING_FOR_APPROVAL_MODAL = 'OPEN_WAITING_FOR_APPROVAL_MODAL';
export const OPEN_EXCLUDE_HOUSE_MODAL = 'OPEN_EXCLUDE_HOUSE_MODAL';
export const SET_LOGIN_SIGNUP_TYPE = 'SET_LOGIN_SIGNUP_TYPE';
export const OPEN_CLEAR_CACHE_MODAL = 'OPEN_CLEAR_CACHE_MODAL';

export const AUTO_POP_MODAL_SUCCESS = 'la/ui/autoPopModal/SUCCESS';
export type AUTO_POP_MODAL_SUCCESS_ACTION = TypedActionWithPayload<typeof AUTO_POP_MODAL_SUCCESS, string>;
